var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{staticStyle:{"margin-left":"8px"},attrs:{"target":"_blank","href":"http://beian.miit.gov.cn/"}},[_vm._v(" "+_vm._s(_vm.recordShow)+" ")]),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }